import { UserSessionDataForm } from "./login/user-session-data-form";

export class SessionActivityDataForm {

    sessionActivityId: number;
	activityType : number;
	lastActivitySession : number;
	userDetails: UserSessionDataForm;
	projectId: number;
}
